import { withStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"

const ControlPanelTextField = withStyles((theme) => ({
    root: {
        "& label": {
            color: "#ffffff33",
        },
        "& label.Mui-error": {
            color: theme.palette.error.main,
        },
        "& label.Mui-focused.Mui-error": {
            color: theme.palette.error.main,
        },
        "& label.Mui-focused": {
            color: "#ffffff",
        },
        "&:hover": {
            "& label": {
                color: "#000000",
            },
            "& label.Mui-focused": {
                color: "#ffffff",
            },
            "& input": {
                color: "#000000",
            },
            "& label.Mui-error": {
                color: theme.palette.error.main,
            },
            "& label.Mui-focused.Mui-error": {
                color: theme.palette.error.main,
            },
            "& input.Mui-error": {
                color: theme.palette.error.main,
            },
        },
        "& .MuiOutlinedInput-root": {
            "& input": {
                color: theme.palette.controlPanelInputGrey.main,
            },
            "& fieldset": {
                borderColor: theme.palette.controlPanelInputGrey.main,
            },
            "&:hover fieldset": {
                borderColor: "#000000",
            },
            "&:hover~label": {
                borderColor: "#000000",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#ffffff",
            },
            "&:hover input": {
                color: "#000000",
            },
            "&.Mui-focused input": {
                color: "#ffffff",
            },
            "&.Mui-error:hover fieldset": {
                borderColor: theme.palette.error.main,
            },
            "&.Mui-error:hover~label": {
                borderColor: theme.palette.error.main,
            },
            "&.Mui-error.Mui-focused fieldset": {
                borderColor: theme.palette.error.main,
            },
            "&.Mui-error:hover input": {
                color: theme.palette.error.main,
            },
            "&.Mui-error.Mui-focused input": {
                color: theme.palette.error.main,
            },
        },
    },
}))(TextField)

export default ControlPanelTextField
